import ISBN from 'isbn3';

const extract = (text) => {
  const isbn = ISBN.parse(text.replace(/\s+/g, ''));
  if (isbn) {
    return [isbn.isbn13];
  } else {
    return [];
  }
};

export default { extract };
